import React from "react";
import { Display, Input } from "../../workspace";

function FileUpload({
  fileItems,
  setNewName,
  reduceSize,
  setReduceSize,
  uploadCount,
  uploadTotal,
}) {
  return (
    <div className="flex-parent whole">
      <div className="whole">
        <label className="whole">Image Quality</label>
        <div className="flex-parent whole quality-options">
          <label className="flex-parent">
            <input
              type="radio"
              name="imageQuality"
              value="smaller"
              checked={reduceSize}
              onChange={() => setReduceSize(true)}
            />
            <span>Smaller (better for email/text)</span>
          </label>
          <label className="flex-parent">
            <input
              type="radio"
              name="imageQuality"
              value="full"
              checked={!reduceSize}
              onChange={() => setReduceSize(false)}
            />
            <span>Full Size (for important details)</span>
          </label>
        </div>
      </div>
      {fileItems.map((item, i) => (
        <div className="flex-parent whole photo-item" key={i}>
          <div className="one-fourth image-preview">
            {item.imagePreview && (
              <img
                src={item.imagePreview}
                alt="Preview"
                style={{ maxWidth: "200px", maxHeight: "200px" }}
              />
            )}
          </div>
          <div className="three-fourths">
            <div className="whole">
              <Input
                type="text"
                name="fileName"
                labelText="File Name"
                value={item.newName || ""}
                handleChange={(e) => setNewName(e.target.value, i)}
              />
            </div>
          </div>
        </div>
      ))}
      {uploadTotal > 0 && (
        <div className="whole">
          <Display
            name="uploadProgress"
            label="Progress"
            value={`Uploading ${uploadCount} of ${uploadTotal}...`}
          />
        </div>
      )}
    </div>
  );
}

export default FileUpload;
